import { getStore, setStore, removeStore } from './session'

const sessionId = 'SESSION-ID'
const loginState = 'LOGIN-STATE'

// 获取session
export function getSessionId () {
  return getStore(sessionId)
}

// 设置session
export function setSessionId (sid) {
  return setStore(sessionId, sid)
}

// 删除session
export function removeSessionId () {
  return removeStore(sessionId)
}

// 获取登录态
export function getLoginState () {
  return getStore(loginState)
}

// 设置登录态
export function setLoginState (state) {
  return setStore(loginState, state)
}

// 删除登录态
export function removeLoginState () {
  return removeStore(loginState)
}
